import L from 'leaflet';
import {
  trainPopupTemplate,
  busPopupTemplate
} from './mapTemplates';
import {BusColorEnum} from './BusColorEnum';

const Size = {
  SMALL_ICO: 12,
  MID_ICO: 24,
  BIG_ICO: 34,
  LARGE_ICO: 44,
  POPUP_WIDTH: 286,
  POPOP_POSITION_TRAIN: [0, -28]
};

const getIcon = (data, size, customClassName) => {
  return L.divIcon({
    className: customClassName != null ? `leaflet-data-marker ${customClassName}` : 'leaflet-data-marker',
    html: L.Util.template(data, {}),
    iconAnchor: [size / 2, size / 2],
    iconSize: [size, size],
    popupAnchor: Size.POPOP_POSITION_TRAIN
  });
};

const svgTrainLabeled = (label, active) => {
  const textColor = active ? BusColorEnum.BLUE : BusColorEnum.WHITE;
  const borderColor = active ? BusColorEnum.WHITE : BusColorEnum.BLUE;

  return `
<svg width="34" height="34" xmlns="http://www.w3.org/2000/svg">
 <g>
  <rect fill="none" id="canvas_background" height="3.4076" width="3.4076" y="-1" x="-1"/>
 </g>
 <g>
  <g id="Group_45206">
   <circle fill="${borderColor}" r="16" cy="17" cx="17" id="Ellipse_9"/>
   <path fill="${textColor}" d="m17,34a17,17 0 0 1 -12.021,-29.021a17,17 0 1 1 24.042,24.042a16.889,16.889 0 0 1 -12.021,4.979zm0,-32a15,15 0 0 0 -10.607,25.607a15,15 0 0 0 21.214,-21.214a14.9,14.9 0 0 0 -10.607,-4.393z" id="Subtraction_5"/>
  </g>
  <text text-anchor="start" font-size="16" id="svg_1"  x="12.51574514646149" y="22.545432711522256" stroke-width="0" stroke="${textColor}" fill="${textColor}">${label}</text>
 </g>
</svg>
`;
};
const icoTrain = `<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
  <g id="Group_45206" data-name="Group 45206" transform="translate(-3280 554)">
    <circle id="Ellipse_9" data-name="Ellipse 9" cx="16" cy="16" r="16" transform="translate(3281 -553)" fill="${BusColorEnum.BLUE}"/>
    <path id="Subtraction_5" data-name="Subtraction 5" d="M17,34A17,17,0,0,1,4.979,4.979,17,17,0,1,1,29.021,29.021,16.889,16.889,0,0,1,17,34ZM17,2A15,15,0,0,0,6.393,27.607,15,15,0,0,0,27.607,6.393,14.9,14.9,0,0,0,17,2Z" transform="translate(3280 -554)" fill="${BusColorEnum.WHITE}"/>
    <path id="Path_289" data-name="Path 289" d="M594.892,434.35a7.19,7.19,0,0,1-.707-.146,3.176,3.176,0,0,1-2.282-2.478,3.061,3.061,0,0,1-.063-.682q-.006-5.861,0-11.72a3.254,3.254,0,0,1,3.266-3.289q4.82,0,9.643,0A3.247,3.247,0,0,1,608,419.3q0,5.88,0,11.758a3.17,3.17,0,0,1-1.585,2.818,2.881,2.881,0,0,1-1.292.431c-.055,0-.108.013-.177.021.021.055.04.1.059.15q.6,1.371,1.2,2.744a.712.712,0,0,1-.165.876.7.7,0,0,1-1.064-.146,6.854,6.854,0,0,1-.355-.756q-.6-1.377-1.2-2.757a.16.16,0,0,0-.175-.112q-3.328,0-6.654,0a.165.165,0,0,0-.179.125q-.728,1.672-1.461,3.34a.715.715,0,0,1-1.034.391.677.677,0,0,1-.325-.821c.154-.41.338-.806.513-1.208q.364-.842.733-1.68C594.857,434.436,594.873,434.394,594.892,434.35Zm5.039-8.142c1.676,0,3.352-.011,5.028,0a1.094,1.094,0,0,0,1.13-1.127c-.013-1.708,0-3.416,0-5.123a1.394,1.394,0,0,0-.027-.31,1.042,1.042,0,0,0-1.049-.811c-.638,0-1.277,0-1.915,0h-8.205a1.143,1.143,0,0,0-.612.146,1.071,1.071,0,0,0-.526.986c0,1.7,0,3.4,0,5.1a1.055,1.055,0,0,0,1.138,1.14Zm-3.086,4.011a1.234,1.234,0,0,0-1.239-1.237,1.237,1.237,0,1,0,0,2.474A1.232,1.232,0,0,0,596.845,430.219Zm5.746,0a1.238,1.238,0,1,0,1.245-1.233A1.234,1.234,0,0,0,602.591,430.214Z" transform="translate(2697.164 -963.033)" fill="${BusColorEnum.WHITE}"/>
  </g>
</svg>`;
const icoTrainUrl = getIcon(icoTrain, Size.BIG_ICO);
const icoTrainActive = `<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
  <g id="Group_45205" data-name="Group 45205" transform="translate(-3333 554)">
    <circle id="Ellipse_15" data-name="Ellipse 15" cx="16" cy="16" r="16" transform="translate(3334 -553)" fill="${BusColorEnum.WHITE}"/>
    <path id="Subtraction_7" data-name="Subtraction 7" d="M17,34A17,17,0,0,1,4.979,4.979,17,17,0,1,1,29.021,29.021,16.889,16.889,0,0,1,17,34ZM17,2A15,15,0,0,0,6.393,27.607,15,15,0,0,0,27.607,6.393,14.9,14.9,0,0,0,17,2Z" transform="translate(3333 -554)" fill="${BusColorEnum.BLUE}"/>
    <path id="Path_291" data-name="Path 291" d="M594.892,434.35a7.19,7.19,0,0,1-.707-.146,3.176,3.176,0,0,1-2.282-2.478,3.061,3.061,0,0,1-.063-.682q-.006-5.861,0-11.72a3.254,3.254,0,0,1,3.266-3.289q4.82,0,9.643,0A3.247,3.247,0,0,1,608,419.3q0,5.88,0,11.758a3.17,3.17,0,0,1-1.585,2.818,2.881,2.881,0,0,1-1.292.431c-.055,0-.108.013-.177.021.021.055.04.1.059.15q.6,1.371,1.2,2.744a.712.712,0,0,1-.165.876.7.7,0,0,1-1.064-.146,6.854,6.854,0,0,1-.355-.756q-.6-1.377-1.2-2.757a.16.16,0,0,0-.175-.112q-3.328,0-6.654,0a.165.165,0,0,0-.179.125q-.728,1.672-1.461,3.34a.715.715,0,0,1-1.034.391.677.677,0,0,1-.325-.821c.154-.41.338-.806.513-1.208q.364-.842.733-1.68C594.857,434.436,594.873,434.394,594.892,434.35Zm5.039-8.142c1.676,0,3.352-.011,5.028,0a1.094,1.094,0,0,0,1.13-1.127c-.013-1.708,0-3.416,0-5.123a1.394,1.394,0,0,0-.027-.31,1.042,1.042,0,0,0-1.049-.811c-.638,0-1.277,0-1.915,0h-8.205a1.143,1.143,0,0,0-.612.146,1.071,1.071,0,0,0-.526.986c0,1.7,0,3.4,0,5.1a1.055,1.055,0,0,0,1.138,1.14Zm-3.086,4.011a1.234,1.234,0,0,0-1.239-1.237,1.237,1.237,0,1,0,0,2.474A1.232,1.232,0,0,0,596.845,430.219Zm5.746,0a1.238,1.238,0,1,0,1.245-1.233A1.234,1.234,0,0,0,602.591,430.214Z" transform="translate(2750.164 -963.033)" fill="${BusColorEnum.BLUE}"/>
  </g>
</svg>`;
const icoTrainActiveUrl = getIcon(icoTrainActive, Size.BIG_ICO);
const icoExtraordinary = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g id="Group_45207" data-name="Group 45207" transform="translate(-3305 487)">
    <g id="Group_45204" data-name="Group 45204" transform="translate(53 -59)">
      <circle id="Ellipse_14" data-name="Ellipse 14" cx="11" cy="11" r="11" transform="translate(3253 -427)" fill="${BusColorEnum.YELLOW}"/>
      <path id="Subtraction_6" data-name="Subtraction 6" d="M12,24A12,12,0,0,1,3.515,3.515,12,12,0,1,1,20.485,20.485,11.922,11.922,0,0,1,12,24ZM12,2.412A9.588,9.588,0,1,0,21.588,12,9.6,9.6,0,0,0,12,2.412Z" transform="translate(3252 -428)" fill="${BusColorEnum.WHITE}"/>
      <path id="Path_290" data-name="Path 290" d="M644.909,430.834H633.182c-.658,0-1.04-.378-1.04-.871a1.276,1.276,0,0,1,.2-.65l5.85-10.519a.97.97,0,0,1,1.788.014l5.766,10.505a1.277,1.277,0,0,1,.2.65C645.947,430.456,645.565,430.834,644.909,430.834Zm-5.785-9.069a.684.684,0,0,1,.684.684V425.7a.685.685,0,0,1-1.369,0v-3.251a.684.684,0,0,1,.683-.684Zm.012,5.987a.649.649,0,0,1,.482.2.67.67,0,0,1,.2.488.649.649,0,0,1-.2.511.676.676,0,0,1-.474.182.694.694,0,0,1-.484-.182.641.641,0,0,1-.206-.511.676.676,0,0,1,.668-.684Z" transform="translate(2624.858 -842.033)" fill="${BusColorEnum.WHITE}" fill-rule="evenodd"/>
    </g>
  </g>
</svg>`;
const icoExtraordinaryUrl = getIcon(icoExtraordinary, Size.MID_ICO);

const svgBus = (label, state, angle, active) => {
  const style = `style="transform: rotate(${angle}deg)"`;
  return `
<div class="${active ? 'leafletmaps-marker leafletmaps-marker--active' : 'leafletmaps-marker'}">
  ${state === 'v pohybu' ? `
  <div class="leafletmaps-marker__arrow-container" ${style}>
    <div class="leafletmaps-marker__hyphen"></div>
    <div class="leafletmaps-marker__arrow"></div>
  </div>
    ` :
    ''}
  <span class="leafletmaps-marker__content">
    ${label}
  </span>
</div>
`;
};


const trackTrainTooltipOptions = {
  className: 'map__tooltip map__tooltip--train',
  offset: [-15, 0],
  direction: 'left'
};

export const mapTrackCircle = (point, {type = 8, name}) => {
  const circleMarker = L.circleMarker(point, {
    color: BusColorEnum.WHITE,
    fillColor: BusColorEnum.GREEN,
    fillOpacity: 1,
    weight: 2,
    radius: type === 4 ? (Size.BIG_ICO / 2) : (Size.SMALL_ICO / 2)
  });
  if (name) {
    circleMarker.bindTooltip(name, trackTrainTooltipOptions);
  }
  return circleMarker;
};

export const mapTrainCircleMarker = ({
  point,
  popupData,
  stationNameEnum
}) => {

  const icon = popupData.length > 1 ? getIcon(svgTrainLabeled(popupData.length), Size.BIG_ICO) : icoTrainUrl;
  const activeIcon = popupData.length > 1 ? getIcon(svgTrainLabeled(popupData.length, true), Size.BIG_ICO) : icoTrainActiveUrl;
  const marker = L.marker(point, {
    icon: icon
  });
  marker.bindPopup(trainPopupTemplate(popupData, stationNameEnum), {
    className: 'map__popup',
    minWidth: Size.POPUP_WIDTH,
    maxWidth: Size.POPUP_WIDTH,
    offset: [50 + (Size.POPUP_WIDTH / 2), 0]
  }).on('popupopen', () => {
    marker.setIcon(activeIcon);
  }).on('popupclose', () => {
    marker.setIcon(icon);
  });
  return marker;
};

export const mapBusCircleMarker = ({
  point,
  filteredData
}, onOpen) => {

  const {
    linkNumberAlias,
    state,
    angle
  } = filteredData;

  const icon = getIcon(svgBus(linkNumberAlias, state, angle, false), Size.BIG_ICO);
  const activeIcon = getIcon(svgBus(linkNumberAlias, state, angle, true), Size.LARGE_ICO, 'leaflet-data-marker--upper');

  const marker = L.marker(point, {icon: icon});

  marker.bindPopup(busPopupTemplate(filteredData), {
    className: 'map__popup'
  }).on('popupopen', () => {
    if (onOpen) {
      onOpen(filteredData);
    }
    marker.setIcon(activeIcon);
  }).on('popupclose', () => {
    if (onOpen) {
      onOpen([]);
    }
    marker.setIcon(icon);
  });

  return marker;
};

export const mapLine = ({latLngs, href, color, borderColor, hover = true}) => {
  const lineForBorder = L.polyline(latLngs, {
    color: borderColor,
    weight: 8
  });
  const line = L.polyline(latLngs, {color: color, weight: 4});

  const group = L.featureGroup([line, lineForBorder]);
  group.setActive = (active) => {
    if (active) {
      lineForBorder.setStyle({color: color});
      line.setStyle({color: borderColor});
    } else {
      lineForBorder.setStyle({color: borderColor});
      line.setStyle({color: color});
    }
  };

  if (href) {
    group.on('click', () => {
      window.location.href = href;
    });
  }
  if (hover) {
    group.on('mouseover', () => {
      group.setActive(true);
    });
    group.on('mouseout', () => {
      group.setActive(false);
    });
  }
  return group;
};

export const mapMarkerExtraordinaryLockout = (point) => {
  const marker = L.marker(point, {
    icon: icoExtraordinaryUrl
  });
  return marker;
};

export const mapGroup = ({
  icon,
  iconTooltip,
  iconToolTipData,
  showIconOnlyOnFirstPoint = false,
  activateCompleteLayer = false,
  lineColor,
  lineBorderColor,
  data,
  map,
  popup,
  popupData
}) => {
  const subGroup = L.featureGroup().addTo(map);
  subGroup.setActive = (active) => {
    subGroup.eachLayer((layer) => {
      if (layer.setActive) {
        layer.setActive(active);
      }
    });
  };
  data.forEach((pointData, index) => {
    const {lat, lng} = pointData;
    if (index > 0) {
      const prevPoint = data[index - 1];
      const latLngs = [
        [lat, lng],
        [prevPoint.lat, prevPoint.lng]
      ];

      const trackLine = mapLine({
        latLngs,
        color: lineColor,
        borderColor: lineBorderColor,
        href: pointData.url || pointData.href,
        hover: !activateCompleteLayer
      }).addTo(map);
      if (!activateCompleteLayer) {
        trackLine.on('mouseover', () => {
          trackLine.setActive(true);
        });
        trackLine.on('mouseout', () => {
          trackLine.setActive(false);
        });
      }
      trackLine.bringToBack();
      subGroup.addLayer(trackLine);
    }

    if (icon && !showIconOnlyOnFirstPoint) {
      const marker = icon([lat, lng], pointData).addTo(map);
      if (iconTooltip) {
        marker.bindTooltip(iconTooltip(iconToolTipData), trackTrainTooltipOptions);
      }
      subGroup.addLayer(marker);
    }
    if (icon && showIconOnlyOnFirstPoint && index === 0) {
      const marker = icon([lat, lng], pointData).addTo(map);
      if (iconTooltip) {
        marker.bindTooltip(iconTooltip(iconToolTipData), trackTrainTooltipOptions);
      }
      subGroup.addLayer(marker);
    }
  });
  if (popup) {
    subGroup.bindPopup(popup(popupData, data), {
      className: 'map__popup',
      minWidth: Size.POPUP_WIDTH,
      maxWidth: Size.POPUP_WIDTH,
      offset: [50 + (Size.POPUP_WIDTH / 2), 0]
    }).on('popupopen', () => {
      subGroup.hasPopup = true;
      subGroup.setActive(true);
    }).on('popupclose', () => {
      subGroup.has = false;
      subGroup.setActive(false);
    });
  }
  if (activateCompleteLayer) {
    subGroup.on('mouseover', () => {
      subGroup.setActive(true);
    });
    subGroup.on('mouseout', () => {
      if (!subGroup.hasPopup) {
        subGroup.setActive(false);
      }
    });
  }
  return subGroup;
};

export const renderExclusions = ({
  map, data, lineColor, lineBorderColor, icon, popup, iconTooltip
}) => {
  const group = L.featureGroup().addTo(map);
  data.forEach((itemData) => {
    const {stops} = itemData;
    const subGroup = mapGroup({
      data: stops,
      lineColor,
      lineBorderColor,
      icon: icon ? (point, pointData) => icon(point) : undefined,
      iconTooltip,
      iconToolTipData: itemData,
      map,
      showIconOnlyOnFirstPoint: true,
      activateCompleteLayer: true,
      popup,
      popupData: itemData
    });
    group.addLayer(subGroup);
  });
  return group;
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Map/mapShapes.js